<template>
  <i class="fa-solid fa-folder text-yellow-500"></i>
</template>
